import React, { useState, useEffect, useMemo } from 'react'
import { Text } from '@react-three/drei';

import { const_var, params } from '../../../../../redux/reducers/reducer';
import { convertFeet } from '../../../../../utils/ConvertFeet';

import LineModel from '../../LineModel'
import DimensionValue from '../../DimensionValue';
import { convertSizeFormat, sortDoorObject } from '../../../../../utils/Functions';
import DoorSideLine from '../../DoorSideLine';
import { wallNameArrForValid } from '../../../../../utils/Validation';

const Window_Measurements = ({isDrag, bindDelta, positionX, positionY, positionZ, height, width, wallName, id, color="#2F7CBF"}) => {
    const [ widthLeft, setWidthLeft] = useState(params.p_w / 2 - width / 2);
    const [ widthRight, setWidthRight] = useState(params.p_w / 2 - width / 2);
    const [ topHeight, setTopHeight ] = useState(0)
    const [ bottomHeight, setBottomHeight ] = useState(0)
    const [ lefthHorizontalArrowLength, setLeftHorizontalArrowLength] = useState(0);
    const [ rightHorizontalArrowLength, setRightHorizontalArrowLength] = useState(0);
    const [ verticalArrowLength, setVerticalArrowLength ] = useState(0);
    const [ leftHorizontalArrowPosition, setLeftHorizontalArrowPosition ] = useState(0)
    const [ rightHorizontalArrowPosition, setRightHorizontalArrowPosition ] = useState(0)
    const [targetDoorSize, setTargetDoorSize] = useState('');
    // const [leftPositionX, setLeftPositionX] = useState(-width / 2 - 2);
    const [leftAngle, setLeftAngle] = useState(0);
    // const [rightPositionX, setRightPositionX] = useState(width / 2 + 2);
    const [rightAngle, setRightAngle] = useState(0);

    const sideDoorArray = const_var.newDoorsArray.filter((item) => item.userData.wallName === wallName);
    
    const limitY = useMemo(() => {
        let regularHeight = 0;

        if (params.p_r_s === 1) {
            regularHeight = const_var.roofRegularDst * 2;
        } else if (params.p_r_s === 2) {
            regularHeight = 0;
        } else if (params.p_r_s === 3) {
            regularHeight = 0;
        }
        
        if (params.singleSlope) {
            if (wallName === 'c_b_f_w' || wallName === 'c_b_f_s_w') {
                return params.p_h - (params.p_r_p / 12) * ((params.p_w / 2) - positionX);
            } else if(wallName === 'c_b_b_w'){
                return params.p_h - (params.p_r_p / 12) * ((params.p_w / 2) + positionX);
            } else if (wallName === 'c_b_l_w' || wallName === 'c_b_l_s_w') {
                return params.p_h - (params.p_r_p / 12) * params.p_w;
            } else if (wallName === 'c_b_r_w' || wallName === 'c_b_r_s_w') {
                return params.p_h;
            } else if (wallName === 'c_b_l_s_r_w') {
                return params.p_h - (params.p_w - (parseInt(params.cB_addStorage_left)) + 0.0075) * params.p_r_p / 12;
            } else if (wallName === 'c_b_l_s_f_w') {
                return params.p_h - (params.p_w - (parseInt(params.cB_addStorage_left)) + 0.0075 - positionX) * params.p_r_p / 12;
            } else if (wallName === 'c_b_l_s_b_w') {
                return params.p_h - (params.p_w - (parseInt(params.cB_addStorage_left)) + 0.0075 + positionX) * params.p_r_p / 12;
            } else if (wallName === 'c_b_r_s_l_w') {
                return params.p_h - (parseInt(params.cB_addStorage_right) + 0.0075) * params.p_r_p / 12;
            } else if (wallName === 'c_b_r_s_f_w') {
                return params.p_h - (params.p_w - (parseInt(params.cB_addStorage_right)) + 0.0075 - positionX) * params.p_r_p / 12;
            } else if (wallName === 'c_b_r_s_b_w') {
                return params.p_h - (params.p_w - (parseInt(params.cB_addStorage_right)) + 0.0075 + positionX) * params.p_r_p / 12;
            } else if (wallName === 'R_L_F_W' || wallName === 'R_L_F_S_W') {
                return params.leanR_p_h + (params.b_l_t_r_pR / 12) * (params.p_w / 2 + params.leanR_p_w - positionX) + regularHeight;
            } else if (wallName === 'R_L_B_W') {
                return params.leanR_p_h + (params.b_l_t_r_pR / 12) * (params.p_w / 2 + params.leanR_p_w + positionX) + regularHeight;
            } else if (wallName === 'R_L_R_W' || wallName === 'R_L_R_S_W') {
                return params.leanR_p_h;
            }
        } else {
            if (wallName === 'c_b_f_w' || wallName === 'c_b_b_w' || wallName === 'c_b_f_s_w') {
                return params.p_h + (params.p_r_p / 12) * ((params.p_w / 2) - Math.abs(positionX)) + regularHeight;
            } else if (wallName === 'c_b_l_w' || wallName === 'c_b_r_w' || wallName === 'c_b_r_s_w' || wallName === 'c_b_l_s_w') {
                return params.p_h;
            } else if (wallName === 'F_L_R_W' || wallName === 'F_L_R_S_W') {
                return params.leanF_p_h + (params.b_l_t_r_pF / 12) * (params.p_d / 2 + params.leanF_p_w + positionX) + regularHeight;
            } else if (wallName === 'F_L_L_W') {
                return params.leanF_p_h + (params.b_l_t_r_pF / 12) * (params.p_d / 2 + params.leanF_p_w - positionX) + regularHeight;
            } else if (wallName === 'F_L_F_W' || wallName === 'F_L_F_S_W') {
                return params.leanF_p_h;
            } else if (wallName === 'B_L_F_W' || wallName === 'B_L_L_S_W') {
                return params.leanB_p_h + (params.b_l_t_r_pB / 12) * (params.p_d / 2 + params.leanB_p_w - positionX ) + regularHeight;
            } else if (wallName === 'B_L_B_W') {
                return params.leanB_p_h + (params.b_l_t_r_pB / 12) * (params.p_d / 2 + params.leanB_p_w + positionX ) + regularHeight;
            } else if (wallName === 'B_L_S_W' || wallName === 'B_L_F_S_W') {
                return params.leanB_p_h;
            } else if (wallName === 'R_L_F_W' || wallName === 'R_L_F_S_W') {
                return params.leanR_p_h + (params.b_l_t_r_pR / 12) * (params.p_w / 2 + params.leanR_p_w - positionX) + regularHeight;
            } else if (wallName === 'R_L_B_W') {
                return params.leanR_p_h + (params.b_l_t_r_pR / 12) * (params.p_w / 2 + params.leanR_p_w + positionX) + regularHeight;
            } else if (wallName === 'R_L_R_W' || wallName === 'R_L_R_S_W') {
                return params.leanR_p_h;
            } else if (wallName === 'L_L_F_W' || wallName === 'L_L_F_S_W') {
                return  params.lean_p_h + (params.b_l_t_r_p / 12) * (params.p_w / 2 + params.lean_p_w + positionX) + regularHeight;
            } else if (wallName === 'L_L_B_W' || wallName === 'L_L_B_S_W') {
                return params.lean_p_h + (params.b_l_t_r_p / 12) * (params.p_w / 2 + params.lean_p_w - positionX) + regularHeight;
            } else if (wallName === 'L_L_L_W' || wallName === 'L_L_L_S_W') {
                return params.lean_p_h;
            } else if (wallName === 'G_L_L_F_W' || wallName === 'G_L_L_F_S_W') {
                return params.lean_p_h + (params.b_l_t_r_p / 12) * (params.lean_p_w / 2 - Math.abs(positionX - params.lean_p_pos)) + regularHeight;
            } else if (wallName === 'G_L_L_B_W' || wallName === 'G_L_L_B_S_W') {
                return params.lean_p_h + (params.b_l_t_r_p / 12) * (params.lean_p_w / 2 - Math.abs(positionX + params.lean_p_pos)) + regularHeight;
            } else if (wallName === 'G_L_L_L_W' || wallName === 'G_L_L_L_S_W' || wallName === 'G_L_L_R_W' || wallName === 'G_L_L_R_S_W') {
                return params.lean_p_h + regularHeight;
            } else if (wallName === 'G_R_L_F_W' || wallName === 'G_R_L_F_S_W') {
                return params.leanR_p_h + (params.b_l_t_r_pR / 12) * (params.leanR_p_w / 2 - Math.abs(positionX + params.leanR_p_pos)) + regularHeight;
            } else if (wallName === 'G_R_L_B_W' || wallName === 'G_R_L_B_S_W') {
                return params.leanR_p_h + (params.b_l_t_r_pR / 12) * (params.leanR_p_w / 2 - Math.abs(positionX - params.leanR_p_pos)) + regularHeight;
            } else if (wallName === 'G_R_L_L_W' || wallName === 'G_R_L_L_S_W' || wallName === 'G_R_L_R_W' || wallName === 'G_R_L_R_S_W') {
                return params.leanR_p_h + regularHeight;
            } else if (wallName === 'G_F_L_F_W' || wallName === 'G_F_L_F_S_W') {
                return params.leanF_p_h + (params.b_l_t_r_pF / 12) * (params.leanF_p_w / 2 - Math.abs(positionX - params.leanF_p_pos)) + regularHeight;
            } else if (wallName === 'G_F_L_B_W' || wallName === 'G_F_L_B_S_W') {
                return params.leanF_p_h + (params.b_l_t_r_pF / 12) * (params.leanF_p_w / 2 - Math.abs(positionX + params.leanF_p_pos)) + regularHeight;
            } else if (wallName === 'G_F_L_L_W' || wallName === 'G_F_L_L_S_W' || wallName === 'G_F_L_R_W' || wallName === 'G_F_L_R_S_W') {
                return params.leanF_p_h + regularHeight;
            } else if (wallName === 'G_B_L_F_W' || wallName === 'G_B_L_F_S_W') {
                return params.leanB_p_h + (params.b_l_t_r_pB / 12) * (params.leanB_p_w / 2 - Math.abs(positionX + params.leanB_p_pos)) + regularHeight;
            } else if (wallName === 'G_B_L_B_W' || wallName === 'G_B_L_B_S_W') {
                return params.leanB_p_h + (params.b_l_t_r_pB / 12) * (params.leanB_p_w / 2 - Math.abs(positionX - params.leanB_p_pos)) + regularHeight;
            } else if (wallName === 'G_B_L_L_W' || wallName === 'G_B_L_L_S_W' || wallName === 'G_B_L_R_W' || wallName === 'G_B_L_R_S_W') {
                return params.leanB_p_h + regularHeight;
            } else if (wallName === 'c_b_l_s_r_w') {
                let overHeight = 0;
                if (parseInt(params.cB_addStorage_left) < params.p_w / 2) {
                    overHeight = (parseInt(params.cB_addStorage_left) + 0.0075) * params.p_r_p / 12 + regularHeight;
                } else {
                    overHeight = (params.p_w - parseInt(params.cB_addStorage_left) + 0.0075) * params.p_r_p / 12 + regularHeight;
                }

                return params.p_h + overHeight;
            } else if (wallName === 'c_b_l_s_f_w' || wallName === 'c_b_l_s_b_w') {
                return params.p_h + (params.p_r_p / 12) * ((params.p_w / 2) - Math.abs(positionX)) + regularHeight;
            } else if (wallName === 'c_b_r_s_l_w') {
                let overHeight = 0;
                if (parseInt(params.cB_addStorage_right) < params.p_w / 2) {
                    overHeight = (parseInt(params.cB_addStorage_right) + 0.0075) * params.p_r_p / 12 + regularHeight;
                } else {
                    overHeight = (params.p_w - parseInt(params.cB_addStorage_right) + 0.0075) * params.p_r_p / 12 + regularHeight;
                }

                return params.p_h + overHeight;
            } else if (wallName === 'c_b_r_s_f_w' || wallName === 'c_b_r_s_b_w') {
                return params.p_h + (params.p_r_p / 12) * ((params.p_w / 2) - Math.abs(positionX)) + regularHeight;
            } else if (wallName === 'R_L_L_S_W') {
                return params.leanR_p_h + (params.b_l_t_r_pR / 12) * params.leanR_p_w;
            } else if (wallName === 'L_L_R_S_W') {
                return params.lean_p_h + (params.b_l_t_r_p / 12) * params.lean_p_w;
            }
        }
    
    }, [wallName, positionX, params.singleSlope, params.p_w, params.p_h, params.p_r_s, params.p_r_p, params.leanF_p_h, params.leanF_p_w, params.b_l_t_r_pF, params.leanB_p_h, params.leanB_p_w, params.b_l_t_r_pB, params.leanR_p_h, params.leanR_p_w, params.b_l_t_r_pR, params.lean_p_h, params.lean_p_w, params.b_l_t_r_p, params.cB_addStorage_left, params.cB_addStorage_right]);

    const limitX = useMemo(() => {
        const trimHeight = 0.1;
        let regularHeight = 0;

        if (params.p_r_s === 1) {
            regularHeight = const_var.roofRegularDst * 2;
        } else if (params.p_r_s === 2) {
            regularHeight = 0;
        } else if (params.p_r_s === 3) {
            regularHeight = 0;
        }

        const alpha = Math.atan(params.p_r_p / 12);
        const frontLeanAlpha = Math.atan(params.b_l_t_r_pF / 12);
        const backLeanAlpha = Math.atan(params.b_l_t_r_pB / 12);
        const leftLeanAlpha = Math.atan(params.b_l_t_r_p / 12);
        const rightLeanAlpha = Math.atan(params.b_l_t_r_pR / 12);

        if (params.singleSlope) {
            if (wallName === 'c_b_f_w' || wallName === 'c_b_f_s_w') {
                const maxHeight = params.p_h - trimHeight;
                if (positionY <= params.p_h - (params.p_r_p / 12) * params.p_w - trimHeight) {
                    return {
                        min: -(params.p_w / 2),
                        max: params.p_w / 2
                    }
                } else {
                    const minValue = -params.p_w / 2 + (maxHeight - positionY) / Math.tan(alpha);
                    return {
                        min: -minValue,
                        max: params.p_w / 2
                    }
                }
            } else if (wallName === 'c_b_b_w' || wallName === 'c_b_b_s_w') {
                const maxHeight = params.p_h - trimHeight;
                if (positionY <= params.p_h - (params.p_r_p / 12) * params.p_w - trimHeight) {
                    return {
                        min: -(params.p_w / 2),
                        max: params.p_w / 2
                    }
                } else {
                    const minValue = params.p_w / 2 - (maxHeight - positionY) / Math.tan(alpha);
                    return {
                        min: -params.p_w / 2,
                        max: -minValue
                    }
                }
            } else if (wallName === 'c_b_l_w' || wallName === 'c_b_r_w' || wallName === 'c_b_l_s_r_w' || wallName === 'c_b_r_s_l_w') {
                return {
                    min: -(params.p_d / 2),
                    max: params.p_d / 2
                }
            } else if (wallName === 'c_b_r_s_w') {
                return {
                    min: -(parseInt(params.p_u_t) - params.p_d / 2) - params.endStoragePositionZ,
                    max: params.p_d / 2 - params.endStoragePositionZ
                }
            } else if (wallName === 'c_b_l_s_w') {
                return {
                    min: -(params.p_d / 2) + params.endStoragePositionZ,
                    max: parseInt(params.p_u_t) - params.p_d / 2 + params.endStoragePositionZ
                }
            } else if (wallName === 'c_b_l_s_f_w') {
                const maxHeight = params.p_h - trimHeight;
                if (positionY <= params.p_h - (params.p_r_p / 12) * params.p_w - trimHeight) {
                    return {
                        min: -(params.p_w / 2),
                        max: -params.p_w / 2 + parseInt(params.cB_addStorage_left)
                    }
                } else {
                    const minValue = -params.p_w / 2 + (maxHeight - positionY) / Math.tan(alpha);
                    return {
                        min: -minValue,
                        max: -params.p_w / 2 + parseInt(params.cB_addStorage_left)
                    }
                }
            } else if (wallName === 'c_b_l_s_b_w') {
                const maxHeight = params.p_h - trimHeight;
                if (positionY <= params.p_h - (params.p_r_p / 12) * params.p_w - trimHeight) {
                    return {
                        min: params.p_w / 2 - parseInt(params.cB_addStorage_left),
                        max: params.p_w / 2
                    }
                } else {
                    const minValue = params.p_w / 2 - (maxHeight - positionY) / Math.tan(alpha);
                    return {
                        min: params.p_w / 2 - parseInt(params.cB_addStorage_left),
                        max: -minValue
                    }
                }
            } else if (wallName === 'c_b_r_s_f_w') {
                const maxHeight = params.p_h - trimHeight;
                if (positionY <= params.p_h - (params.p_r_p / 12) * parseInt(params.cB_addStorage_right) - trimHeight) {
                    return {
                        min: params.p_w / 2 - parseInt(params.cB_addStorage_right),
                        max: params.p_w / 2
                    }
                } else {
                    const minValue = -params.p_w / 2 + (maxHeight - positionY) / Math.tan(alpha);
                    return {
                        min: -minValue,
                        max: params.p_w / 2
                    }
                }
            } else if (wallName === 'c_b_r_s_b_w') {
                const maxHeight = params.p_h - trimHeight;
                if (positionY <= params.p_h - (params.p_r_p / 12) * parseInt(params.cB_addStorage_right) - trimHeight) {
                    return {
                        min: -(params.p_w / 2),
                        max: -params.p_w / 2 + parseInt(params.cB_addStorage_right)
                    }
                } else {
                    const minValue = params.p_w / 2 - (maxHeight - positionY) / Math.tan(alpha);
                    return {
                        min: -params.p_w / 2,
                        max: -minValue
                    }
                }
            }
            else if (wallName === 'R_L_F_W' || wallName === 'R_L_F_S_W') {
                const maxHeight = params.leanR_p_h + (params.b_l_t_r_pR / 12) * params.leanR_p_w + regularHeight - trimHeight;
                if (positionY <= params.leanR_p_h + regularHeight - trimHeight) {
                    return {
                        min: params.p_w / 2,
                        max: params.p_w / 2 + params.leanR_p_w
                    }
                } else {
                    const minValue = (maxHeight - positionY) / Math.tan(rightLeanAlpha);
                    return {
                        min: params.p_w / 2,
                        max: params.p_w / 2 + minValue
                    }
                }
            } else if (wallName === 'R_L_B_W' || wallName === 'R_L_B_S_W') {
                const maxHeight = params.leanR_p_h + (params.b_l_t_r_pR / 12) * params.leanR_p_w + regularHeight - trimHeight;
                if (positionY <= params.leanR_p_h + regularHeight - trimHeight) {
                    return {
                        min: -params.p_w / 2 - params.leanR_p_w,
                        max: -params.p_w / 2
                    }
                } else {
                    const minValue = (maxHeight - positionY) / Math.tan(rightLeanAlpha);
                    return {
                        min: -params.p_w / 2 - minValue,
                        max: -params.p_w / 2
                    }
                }
            }
            else if (wallName === 'R_L_R_W') {
                return {
                    min: params.add_right_front_lean_porch ? -params.leanR_p_pos - params.leanR_p_d / 2 - params.leanF_p_w : -params.leanR_p_pos - params.leanR_p_d / 2,
                    max: params.add_right_back_lean_porch ? -params.leanR_p_pos + params.leanR_p_d / 2 + params.leanB_p_w : -params.leanR_p_pos + params.leanR_p_d / 2
                }
            }
            else if (wallName === 'R_L_R_S_W') {
                return {
                    min: -params.leanR_p_pos + params.leanR_p_d / 2 - parseInt(params.add_storage_right) - params.rightLeanStoragePosition,
                    max: -params.leanR_p_pos + params.leanR_p_d / 2 - params.rightLeanStoragePosition
                }
            }
            else if (wallName === 'R_L_L_S_W') {
                return {
                    min: params.leanR_p_pos - params.leanR_p_d / 2 + params.rightLeanStoragePosition,
                    max: params.leanR_p_pos - params.leanR_p_d / 2 + parseInt(params.add_storage_right) + params.rightLeanStoragePosition
                } 
            }
        } else {
            if(wallName === 'c_b_f_w' || wallName === 'c_b_b_w' || wallName === 'c_b_f_s_w' || wallName === 'c_b_b_s_w') {
                const maxHeight = params.p_h + (params.p_r_p / 12) * params.p_w / 2 + regularHeight - trimHeight;
                if (positionY <= params.p_h + regularHeight - trimHeight) {
                    return {
                        min: -(params.p_w / 2),
                        max: params.p_w / 2
                    }
                } else {
                    const minValue = (maxHeight - positionY) / Math.tan(alpha);
                    return {
                        min: -(minValue),
                        max: minValue
                    }
                }
            } else if (wallName === 'c_b_l_w' || wallName === 'c_b_r_w' || wallName === 'c_b_l_s_r_w' || wallName === 'c_b_r_s_l_w') {
                return {
                    min: -(params.p_d / 2),
                    max: params.p_d / 2
                }
            } else if (wallName === 'F_L_R_W' || wallName === 'F_L_R_S_W') {
                const maxHeight = params.leanF_p_h + (params.b_l_t_r_pF / 12) * params.leanF_p_w + regularHeight - trimHeight;
                if (positionY <= params.leanF_p_h + regularHeight - trimHeight) {
                    return {
                        min: -params.p_d / 2 - 0.15 - params.leanF_p_w,
                        max: -params.p_d / 2 - 0.15
                    }
                } else {
                    const minValue = (maxHeight - positionY) / Math.tan(frontLeanAlpha);
                    return {
                        min: -params.p_d / 2 - 0.15 - minValue,
                        max: -params.p_d / 2 - 0.15
                    }
                }
            } else if (wallName === 'F_L_L_W' || wallName === 'F_L_L_S_W') {
                const maxHeight = params.leanF_p_h + (params.b_l_t_r_pF / 12) * params.leanF_p_w + regularHeight - trimHeight;
                if (positionY <= params.leanF_p_h + regularHeight - trimHeight) {
                    return {
                        min: params.p_d / 2 + 0.15,
                        max: params.p_d / 2 + 0.15 + params.leanF_p_w
                    }
                } else {
                    const minValue = (maxHeight - positionY) / Math.tan(frontLeanAlpha);
                    return {
                        min: params.p_d / 2 + 0.15,
                        max: params.p_d / 2 + 0.15 + minValue
                    }
                }
            } else if (wallName === 'F_L_F_W') {
                return {
                    min: params.add_left_front_lean_porch ? params.leanF_p_pos - params.leanF_p_d / 2 - params.lean_p_w : params.leanF_p_pos - params.leanF_p_d / 2,
                    max: params.add_right_front_lean_porch ? params.leanF_p_pos + params.leanF_p_d / 2 + params.leanR_p_w : params.leanF_p_pos + params.leanF_p_d / 2
                }
            } else if (wallName === 'B_L_F_W' || wallName === 'B_L_L_S_W') {
                const maxHeight = params.leanB_p_h + (params.b_l_t_r_pB / 12) * params.leanB_p_w + regularHeight - trimHeight;
                if (positionY <= params.leanB_p_h + regularHeight - trimHeight) {
                    return {
                        min: params.p_d / 2 + 0.15,
                        max: params.p_d / 2 + 0.15 + params.leanB_p_w
                    }
                } else {
                    const minValue = (maxHeight - positionY) / Math.tan(backLeanAlpha);
                    return {
                        min: params.p_d / 2 + 0.15,
                        max: params.p_d / 2 + 0.15 + minValue
                    }
                }
            } else if (wallName === 'B_L_B_W' || wallName === 'B_L_R_S_W') {
                const maxHeight = params.leanB_p_h + (params.b_l_t_r_pB / 12) * params.leanB_p_w + regularHeight - trimHeight;
                if (positionY <= params.leanB_p_h + regularHeight - trimHeight) {
                    return {
                        min: -params.p_d / 2 - 0.15 - params.leanB_p_w,
                        max: -params.p_d / 2 - 0.15
                    }
                } else {
                    const minValue = (maxHeight - positionY) / Math.tan(backLeanAlpha);
                    return {
                        min: -params.p_d / 2 - 0.15 - minValue,
                        max: -params.p_d / 2 - 0.15
                    }
                }
            } else if (wallName === 'B_L_S_W') {
                return {
                    min: params.add_right_back_lean_porch ? -params.leanB_p_pos - params.leanB_p_d / 2 - params.leanR_p_w : -params.leanB_p_pos - params.leanB_p_d / 2,
                    max: params.add_left_back_lean_porch ? -params.leanB_p_pos + params.leanB_p_d / 2 + params.lean_p_w : -params.leanB_p_pos + params.leanB_p_d / 2
                }
            } else if (wallName === 'R_L_F_W' || wallName === 'R_L_F_S_W') {
                const maxHeight = params.leanR_p_h + (params.b_l_t_r_pR / 12) * params.leanR_p_w + regularHeight - trimHeight;
                if (positionY <= params.leanR_p_h + regularHeight - trimHeight) {
                    return {
                        min: params.p_w / 2,
                        max: params.p_w / 2 + params.leanR_p_w
                    }
                } else {
                    const minValue = (maxHeight - positionY) / Math.tan(rightLeanAlpha);
                    return {
                        min: params.p_w / 2,
                        max: params.p_w / 2 + minValue
                    }
                }
            } else if (wallName === 'R_L_B_W' || wallName === 'R_L_B_S_W') {
                const maxHeight = params.leanR_p_h + (params.b_l_t_r_pR / 12) * params.leanR_p_w + regularHeight - trimHeight;
                if (positionY <= params.leanR_p_h + regularHeight - trimHeight) {
                    return {
                        min: -params.p_w / 2 - params.leanR_p_w,
                        max: -params.p_w / 2
                    }
                } else {
                    const minValue = (maxHeight - positionY) / Math.tan(rightLeanAlpha);
                    return {
                        min: -params.p_w / 2 - minValue,
                        max: -params.p_w / 2
                    }
                }
            } else if (wallName === 'R_L_R_W') {
                return {
                    min: params.add_right_front_lean_porch ? -params.leanR_p_pos - params.leanR_p_d / 2 - params.leanF_p_w : -params.leanR_p_pos - params.leanR_p_d / 2,
                    max: params.add_right_back_lean_porch ? -params.leanR_p_pos + params.leanR_p_d / 2 + params.leanB_p_w : -params.leanR_p_pos + params.leanR_p_d / 2
                }
            } else if (wallName === 'L_L_F_W' || wallName === 'L_L_F_S_W') {
                const maxHeight = params.lean_p_h + (params.b_l_t_r_p / 12) * params.lean_p_w + regularHeight - trimHeight;
                if (positionY <= params.lean_p_h + regularHeight - trimHeight) {
                    return {
                        min: -params.p_w / 2 - params.lean_p_w,
                        max: -params.p_w / 2
                    }
                } else {
                    const minValue = (maxHeight - positionY) / Math.tan(leftLeanAlpha);
                    return {
                        min: -params.p_w / 2 - minValue,
                        max: -params.p_w / 2
                    }
                }
            } else if (wallName === 'L_L_B_W' || wallName === 'L_L_B_S_W') {
                const maxHeight = params.lean_p_h + (params.b_l_t_r_p / 12) * params.lean_p_w + regularHeight - trimHeight;
                if (positionY <= params.lean_p_h + regularHeight - trimHeight) {
                    return {
                        min: params.p_w / 2,
                        max: params.p_w / 2 + params.lean_p_w
                    }
                } else {
                    const minValue = (maxHeight - positionY) / Math.tan(leftLeanAlpha);
                    return {
                        min: params.p_w / 2,
                        max: params.p_w / 2 + minValue
                    }
                }
            } else if (wallName === 'L_L_L_W') {
                return {
                    min: params.add_left_back_lean_porch ? params.lean_p_pos - params.lean_p_d / 2 - params.leanB_p_w : params.lean_p_pos - params.lean_p_d / 2,
                    max: params.add_left_front_lean_porch ? params.lean_p_pos + params.lean_p_d / 2 + params.leanF_p_w : params.lean_p_pos + params.lean_p_d / 2
                }
            } else if (wallName === 'c_b_r_s_w') {
                return {
                    min: -(parseInt(params.p_u_t) - params.p_d / 2) - params.endStoragePositionZ,
                    max: params.p_d / 2 - params.endStoragePositionZ
                }
            } else if (wallName === 'c_b_l_s_w') {
                return {
                    min: -(params.p_d / 2) + params.endStoragePositionZ,
                    max: parseInt(params.p_u_t) - params.p_d / 2 + params.endStoragePositionZ
                }
            } else if (wallName === 'c_b_l_s_f_w') {
                const maxHeight = params.p_h + (params.p_r_p / 12) * params.p_w / 2 + regularHeight - trimHeight;
                if (positionY <= params.p_h + regularHeight - trimHeight) {
                    return {
                        min: -(params.p_w / 2),
                        max: -params.p_w / 2 + parseInt(params.cB_addStorage_left)
                    }
                } else if (positionY <= maxHeight - Math.tan(alpha) * (parseInt(params.cB_addStorage_left) - params.p_w / 2)) {
                    const minValue = (maxHeight - positionY) / Math.tan(alpha);
                    return {
                        min: -(minValue),
                        max: -params.p_w / 2 + parseInt(params.cB_addStorage_left)
                    }
                } else {
                    const minValue = (maxHeight - positionY) / Math.tan(alpha);
                    return {
                        min: -(minValue),
                        max: minValue
                    }
                }
            } else if (wallName === 'c_b_l_s_b_w') {
                const maxHeight = params.p_h + (params.p_r_p / 12) * params.p_w / 2 + regularHeight - trimHeight;
                if (positionY <= params.p_h + regularHeight - trimHeight) {
                    return {
                        min: params.p_w / 2 - parseInt(params.cB_addStorage_left),
                        max: params.p_w / 2
                    }
                } else if (positionY <= maxHeight - Math.tan(alpha) * (parseInt(params.cB_addStorage_left) - params.p_w / 2)) {
                    const minValue = (maxHeight - positionY) / Math.tan(alpha);
                    return {
                        min: params.p_w / 2 - parseInt(params.cB_addStorage_left),
                        max: minValue
                    }
                } else {
                    const minValue = (maxHeight - positionY) / Math.tan(alpha);
                    return {
                        min: -(minValue),
                        max: minValue
                    }
                }
            } else if (wallName === 'c_b_r_s_f_w') {
                const maxHeight = params.p_h + (params.p_r_p / 12) * params.p_w / 2 + regularHeight - trimHeight;
                if (positionY <= params.p_h + regularHeight - trimHeight) {
                    return {
                        min: params.p_w / 2 - parseInt(params.cB_addStorage_right),
                        max: params.p_w / 2
                    }
                } else if (positionY <= maxHeight - Math.tan(alpha) * (parseInt(params.cB_addStorage_right) - params.p_w / 2)) {
                    const minValue = (maxHeight - positionY) / Math.tan(alpha);
                    return {
                        min: params.p_w / 2 - parseInt(params.cB_addStorage_right),
                        max: minValue
                    }
                } else {
                    const minValue = (maxHeight - positionY) / Math.tan(alpha);
                    return {
                        min: -(minValue),
                        max: minValue
                    }
                }
            } else if (wallName === 'c_b_r_s_b_w') {
                const maxHeight = params.p_h + (params.p_r_p / 12) * params.p_w / 2 + regularHeight - trimHeight;
                if (positionY <= params.p_h + regularHeight - trimHeight) {
                    return {
                        min: -(params.p_w / 2),
                        max: -params.p_w / 2 + parseInt(params.cB_addStorage_right)
                    }
                } else if (positionY <= maxHeight - Math.tan(alpha) * (parseInt(params.cB_addStorage_right) - params.p_w / 2)) {
                    const minValue = (maxHeight - positionY) / Math.tan(alpha);
                    return {
                        min: -(minValue),
                        max: -params.p_w / 2 + parseInt(params.cB_addStorage_right)
                    }
                } else {
                    const minValue = (maxHeight - positionY) / Math.tan(alpha);
                    return {
                        min: -(minValue),
                        max: minValue
                    }
                }
            } else if (wallName === 'F_L_F_S_W') {
                return {
                    min: params.leanF_p_pos - params.leanF_p_d / 2 + params.frontLeanStoragePosition,
                    max: params.leanF_p_pos - params.leanF_p_d / 2 + parseInt(params.add_storage_front) + params.frontLeanStoragePosition
                }
            } else if (wallName === 'B_L_F_S_W') {
                return {
                    min: -params.leanB_p_pos + params.leanB_p_d / 2 - parseInt(params.add_storage_back) - params.backLeanStoragePosition,
                    max: -params.leanB_p_pos + params.leanB_p_d / 2 - params.backLeanStoragePosition
                }
            } else if (wallName === 'R_L_R_S_W') {
                return {
                    min: -params.leanR_p_pos + params.leanR_p_d / 2 - parseInt(params.add_storage_right) - params.rightLeanStoragePosition,
                    max: -params.leanR_p_pos + params.leanR_p_d / 2 - params.rightLeanStoragePosition
                }
            } else if (wallName === 'R_L_L_S_W') {
                return {
                    min: params.leanR_p_pos - params.leanR_p_d / 2 + params.rightLeanStoragePosition,
                    max: params.leanR_p_pos - params.leanR_p_d / 2 + parseInt(params.add_storage_right) + params.rightLeanStoragePosition
                } 
            } else if (wallName === 'L_L_L_S_W') {
                return {
                    min: params.lean_p_pos - params.lean_p_d / 2 + params.leftLeanStoragePosition,
                    max: params.lean_p_pos - params.lean_p_d / 2 + parseInt(params.add_storage) + params.leftLeanStoragePosition
                } 
            } else if (wallName === 'L_L_R_S_W') {
                return {
                    min: -params.lean_p_pos + params.lean_p_d / 2 - parseInt(params.add_storage) - params.leftLeanStoragePosition,
                    max: -params.lean_p_pos + params.lean_p_d / 2 - params.leftLeanStoragePosition
                } 
            } else if (wallName === 'G_L_L_F_W' || wallName === 'G_L_L_F_S_W') {
                return {
                    min: -params.lean_p_w / 2 + params.lean_p_pos,
                    max: params.lean_p_w / 2 + params.lean_p_pos
                }
            } else if (wallName === 'G_L_L_B_W' || wallName === 'G_L_L_B_S_W') {
                return {
                    min: -params.lean_p_w / 2 - params.lean_p_pos,
                    max: params.lean_p_w / 2 - params.lean_p_pos
                }
            } else if (wallName === 'G_L_L_L_W') {
                return {
                    min: params.p_w / 2,
                    max: params.p_w / 2 + params.lean_p_d
                }
            } else if (wallName === 'G_L_L_R_W') {
                return {
                    min: -params.p_w / 2 - params.lean_p_d,
                    max: -params.p_w / 2
                }
            } else if (wallName === 'G_L_L_L_S_W') {
                return {
                    min: params.p_w / 2 + params.leftLeanStoragePosition,
                    max: params.p_w / 2 + params.leftLeanStoragePosition + parseInt(params.add_storage)
                }
            } else if (wallName === 'G_L_L_R_S_W') {
                return {
                    min: -params.p_w / 2 - params.leftLeanStoragePosition - parseInt(params.add_storage),
                    max: -params.p_w / 2 - params.leftLeanStoragePosition
                }
            } else if (wallName === 'G_R_L_F_W' || wallName === 'G_R_L_F_S_W') {
                return {
                    min: -params.leanR_p_w / 2 - params.leanR_p_pos,
                    max: params.leanR_p_w / 2 - params.leanR_p_pos
                }
            } else if (wallName === 'G_R_L_B_W' || wallName === 'G_R_L_B_S_W') {
                return {
                    min: -params.leanR_p_w / 2 + params.leanR_p_pos,
                    max: params.leanR_p_w / 2 + params.leanR_p_pos
                }
            } else if (wallName === 'G_R_L_L_W') {
                return {
                    min: params.p_w / 2,
                    max: params.p_w / 2 + params.leanR_p_d
                }
            } else if (wallName === 'G_R_L_R_W') {
                return {
                    min: -params.p_w / 2 - params.leanR_p_d,
                    max: -params.p_w / 2
                }
            } else if (wallName === 'G_R_L_L_S_W') {
                return {
                    min: params.p_w / 2 + params.rightLeanStoragePosition,
                    max: params.p_w / 2 + params.rightLeanStoragePosition + parseInt(params.add_storage_right)
                }
            } else if (wallName === 'G_R_L_R_S_W') {
                return {
                    min: -params.p_w / 2 - params.rightLeanStoragePosition - parseInt(params.add_storage_right),
                    max: -params.p_w / 2 - params.rightLeanStoragePosition
                }
            } else if (wallName === 'G_F_L_F_W' || wallName === 'G_F_L_F_S_W') {
                return {
                    min: -params.leanF_p_w / 2 + params.leanF_p_pos,
                    max: params.leanF_p_w / 2 + params.leanF_p_pos
                }
            } else if (wallName === 'G_F_L_B_W' || wallName === 'G_F_L_B_S_W') {
                return {
                    min: -params.leanF_p_w / 2 - params.leanF_p_pos,
                    max: params.leanF_p_w / 2 - params.leanF_p_pos
                }
            } else if (wallName === 'G_F_L_L_W') {
                return {
                    min: params.p_d / 2,
                    max: params.p_d / 2 + params.leanF_p_d
                }
            } else if (wallName === 'G_F_L_R_W') {
                return {
                    min: -params.p_d / 2 - params.leanF_p_d,
                    max: -params.p_d / 2
                }
            } else if (wallName === 'G_F_L_L_S_W') {
                return {
                    min: params.p_d / 2 + params.frontLeanStoragePosition,
                    max: params.p_d / 2 + params.frontLeanStoragePosition + parseInt(params.add_storage_front)
                }
            } else if (wallName === 'G_F_L_R_S_W') {
                return {
                    min: -params.p_d / 2 - params.frontLeanStoragePosition - parseInt(params.add_storage_front),
                    max: -params.p_d / 2 - params.frontLeanStoragePosition
                }
            } else if (wallName === 'G_B_L_F_W' || wallName === 'G_B_L_F_S_W') {
                return {
                    min: -params.leanB_p_w / 2 - params.leanB_p_pos,
                    max: params.leanB_p_w / 2 - params.leanB_p_pos
                }
            } else if (wallName === 'G_B_L_B_W' || wallName === 'G_B_L_B_S_W') {
                return {
                    min: -params.leanB_p_w / 2 + params.leanB_p_pos,
                    max: params.leanB_p_w / 2 + params.leanB_p_pos
                }
            } else if (wallName === 'G_B_L_L_W') {
                return {
                    min: params.p_d / 2,
                    max: params.p_d / 2 + params.leanB_p_d
                }
            } else if (wallName === 'G_B_L_R_W') {
                return {
                    min: -params.p_d / 2 - params.leanB_p_d,
                    max: -params.p_d / 2
                }
            } else if (wallName === 'G_B_L_L_S_W') {
                return {
                    min: params.p_d / 2 + params.backLeanStoragePosition,
                    max: params.p_d / 2 + params.backLeanStoragePosition + parseInt(params.add_storage_back)
                }
            } else if (wallName === 'G_B_L_R_S_W') {
                return {
                    min: -params.p_d / 2 - params.backLeanStoragePosition - parseInt(params.add_storage_back),
                    max: -params.p_d / 2 - params.backLeanStoragePosition
                }
            }
        }
    
    }, [wallName, height, params.singleSlope, positionY, params.leftLeanStoragePosition, params.rightLeanStoragePosition, params.backLeanStoragePosition, params.frontLeanStoragePosition, params.p_w, params.p_d, params.p_h, params.p_r_s, params.p_r_p, params.leanF_p_h, params.leanF_p_w, params.leanF_p_d, params.leanF_p_pos, params.b_l_t_r_pF, params.leanB_p_h, params.leanB_p_w, params.leanB_p_d, params.leanB_p_pos, params.b_l_t_r_pB, params.leanR_p_h, params.leanR_p_w, params.leanR_p_d, params.leanR_p_pos, params.b_l_t_r_pR, params.lean_p_h, params.lean_p_w, params.lean_p_d, params.lean_p_pos, params.b_l_t_r_p, params.add_left_front_lean_porch, params.add_right_front_lean_porch, params.add_left_back_lean_porch, params.add_right_back_lean_porch, params.p_u_t, params.cB_addStorage_left, params.cB_addStorage_right, params.add_storage_front, params.add_storage_back, params.add_storage_right, params.add_storage, params.endStoragePositionZ])

    useMemo(() => {
        const arrowLeftHorizontalLengthTemp = Math.abs(limitX.min - positionX + width / 2);
        const arrowRightHorizontalLengthTemp = Math.abs(limitX.max - positionX - width / 2);
    
        const targetWallNameArr = wallNameArrForValid.find(subArray => subArray.includes(wallName));
        const sideArray = [...const_var.newDoorsArray.filter((item) => item.uniqueId !== id && targetWallNameArr.includes(item.userData.wallName) && item.positionY - item.height / 2 <= positionY + height / 2 && item.positionY + item.height / 2 >= positionY - height / 2)];
        const TopBottomArray = [...const_var.newDoorsArray.filter((item) => item.uniqueId !== id && targetWallNameArr.includes(item.userData.wallName) && item.positionX - item.width / 2 <= positionX + width / 2 && item.positionX + item.width / 2 >= positionX - width / 2)];

        let valLeft = limitX.min;
        let valRight = limitX.max;
        let valTop = limitY;
        let valBottom = 0;

        let leftLineLengthOffset = 0;
        let rightLineLengthOffset = 0;
        
        if (TopBottomArray.length > 0) {
            let sortedTopBottomArray;
            let targetIndexTopBottom;

            if (bindDelta[1] >= 0) {
                sortedTopBottomArray = [...TopBottomArray.map(item => ({id: item.uniqueId, posY: item.positionY, height: item.height})), {id, posY: positionY, height}].sort((a, b) => (a.posY - a.height / 2) - (b.posY - b.height / 2));
            } else {
                sortedTopBottomArray = [...TopBottomArray.map(item => ({id: item.uniqueId, posY: item.positionY, height: item.height})), {id, posY: positionY, height}].sort((a, b) => (a.posY + a.height / 2) - (b.posY + b.height / 2));
            }
            targetIndexTopBottom = sortedTopBottomArray.findIndex(el => el.id === id);
            
           if (targetIndexTopBottom === sortedTopBottomArray.length - 1) {
                const frBottomObj = TopBottomArray.find(item => item.uniqueId === sortedTopBottomArray[targetIndexTopBottom - 1].id);
                valBottom = frBottomObj.positionY + frBottomObj.height / 2;
                if (positionY - height / 2 < frBottomObj.positionY + frBottomObj.height / 2) {
                    if (sortedTopBottomArray[targetIndexTopBottom - 2]) {
                        const sdTopObj = TopBottomArray.find(item => item.uniqueId === sortedTopBottomArray[targetIndexTopBottom - 2].id);
                        valBottom = sdTopObj.positionY + sdTopObj.height / 2;
                    } else {
                        valBottom = 0;
                    }
                } 

            } else if(targetIndexTopBottom === 0) {
                const frTopObj = TopBottomArray.find(item => item.uniqueId === sortedTopBottomArray[targetIndexTopBottom + 1].id);
                valTop = frTopObj.positionY - frTopObj.height / 2;
                if (positionY + height / 2 > frTopObj.positionY - frTopObj.height / 2) {
                    if (sortedTopBottomArray[targetIndexTopBottom + 2]) {
                        const sdTopObj = TopBottomArray.find(item => item.uniqueId === sortedTopBottomArray[targetIndexTopBottom + 2].id);
                        valTop = sdTopObj.positionY - sdTopObj.height / 2;
                    } else {
                        valTop = limitY;
                    }
                }
            }else {
                const frTopObj = TopBottomArray.find(item => item.uniqueId === sortedTopBottomArray[targetIndexTopBottom + 1].id);
                const frBottomObj = TopBottomArray.find(item => item.uniqueId === sortedTopBottomArray[targetIndexTopBottom - 1].id);
                valTop = frTopObj.positionY - frTopObj.height / 2;
                valBottom = frBottomObj.positionY + frBottomObj.height / 2;

                if (positionY + height / 2 > frTopObj.positionY - frTopObj.height / 2) {
                    if (sortedTopBottomArray[targetIndexTopBottom + 2]) {
                        const sdTopObj = TopBottomArray.find(item => item.uniqueId === sortedTopBottomArray[targetIndexTopBottom + 2].id);
                        valTop = sdTopObj.positionY - sdTopObj.height / 2;
                    } else {
                        valTop = limitY;
                    }
                }
                if (positionY - height / 2 < frBottomObj.positionY + frBottomObj.height / 2) {
                    if (sortedTopBottomArray[targetIndexTopBottom - 2]) {
                        const sdTopObj = TopBottomArray.find(item => item.uniqueId === sortedTopBottomArray[targetIndexTopBottom - 2].id);
                        valBottom = sdTopObj.positionY + sdTopObj.height / 2;
                    } else {
                        valBottom = 0;
                    }
                } 
            }
        }
        
        if (sideArray.length > 0) {
            let sortedSideArray;
            let targetIndex;

            if (bindDelta[0] >= 0) {
                sortedSideArray = [...sideArray.map(item => ({id: item.uniqueId, posX: item.positionX, width: item.width})), {id, posX: positionX, width}].sort((a, b) => (a.posX - a.width / 2) - (b.posX - b.width / 2));
            } else {
                sortedSideArray = [...sideArray.map(item => ({id: item.uniqueId, posX: item.positionX, width: item.width})), {id, posX: positionX, width}].sort((a, b) => (a.posX + a.width / 2) - (b.posX + b.width / 2));
            }
            targetIndex = sortedSideArray.findIndex(el => el.id === id);

            if (targetIndex === 0) {
                const frRightObj = sideArray.find(item => item.uniqueId === sortedSideArray[targetIndex + 1].id);
                valRight = frRightObj.positionX - frRightObj.width / 2;
                if (positionX + width / 2 > frRightObj.positionX - frRightObj.width / 2) {
                    if (sortedSideArray[targetIndex + 2]) {
                        const sdRightObj = sideArray.find(item => item.uniqueId === sortedSideArray[targetIndex + 2].id);
                        valRight = sdRightObj.positionX - sdRightObj.width / 2;
                    } else {
                        valRight = limitX.max;
                    }
                }
            } else if (targetIndex === sortedSideArray.length - 1) {
                const frLeftObj = sideArray.find(item => item.uniqueId === sortedSideArray[targetIndex - 1].id);
                valLeft = frLeftObj.positionX + frLeftObj.width / 2;
                if (positionX - width / 2 < frLeftObj.positionX + frLeftObj.width / 2) {
                    if (sortedSideArray[targetIndex - 2]) {
                        const sdLeftObj = sideArray.find(item => item.uniqueId === sortedSideArray[targetIndex - 2].id);
                        valLeft = sdLeftObj.positionX + sdLeftObj.width / 2;
                    } else {
                        valLeft = limitX.min;
                    }
                }
            } else {
                const frLeftObj = sideArray.find(item => item.uniqueId === sortedSideArray[targetIndex - 1].id);
                const frRightObj = sideArray.find(item => item.uniqueId === sortedSideArray[targetIndex + 1].id);
                valLeft = frLeftObj.positionX + frLeftObj.width / 2;
                valRight = frRightObj.positionX - frRightObj.width / 2;

                if (positionX + width / 2 > frRightObj.positionX - frRightObj.width / 2) {
                    if (sortedSideArray[targetIndex + 2]) {
                        const sdRightObj = sideArray.find(item => item.uniqueId === sortedSideArray[targetIndex + 2].id);
                        valRight = sdRightObj.positionX - sdRightObj.width / 2;
                    } else {
                        valRight = limitX.max;
                    }
                }
                if (positionX - width / 2 < frLeftObj.positionX + frLeftObj.width / 2) {
                    if (sortedSideArray[targetIndex - 2]) {
                        const sdLeftObj = sideArray.find(item => item.uniqueId === sortedSideArray[targetIndex - 2].id);
                        valLeft = sdLeftObj.positionX + sdLeftObj.width / 2;
                    } else {
                        valLeft = limitX.min;
                    }
                }
            }
            if (valLeft <= limitX.min) valLeft = limitX.min;
            if (valRight >= limitX.max) valRight = limitX.max;
        }

        if (wallName === 'G_L_L_L_S_W') {
            leftLineLengthOffset = 0.2;
            rightLineLengthOffset = 0.1;
            if (params.leftLeanStoragePosition === 0) {
                leftLineLengthOffset = 0;
                rightLineLengthOffset = 0.3;
            }
        } else if (wallName === 'G_L_L_R_S_W') {
            leftLineLengthOffset = 0.1;
            rightLineLengthOffset = 0.2;
            if (params.leftLeanStoragePosition === 0) {
                leftLineLengthOffset = 0.3;
                rightLineLengthOffset = 0;
            }
        } else if (wallName === 'G_R_L_L_S_W') {
            leftLineLengthOffset = 0.2;
            rightLineLengthOffset = 0.1;
            if (params.rightLeanStoragePosition === 0) {
                leftLineLengthOffset = 0;
                rightLineLengthOffset = 0.3;
            }
        } else if (wallName === 'G_R_L_R_S_W') {
            leftLineLengthOffset = 0.1;
            rightLineLengthOffset = 0.2;
            if (params.rightLeanStoragePosition === 0) {
                leftLineLengthOffset = 0.3;
                rightLineLengthOffset = 0;
            }
        } else if (wallName === 'G_F_L_L_S_W') {
            leftLineLengthOffset = 0.2;
            rightLineLengthOffset = 0.15;
            if (params.frontLeanStoragePosition === 0) {
                leftLineLengthOffset = -0.3;
                rightLineLengthOffset = 0.8;
            }
        } else if (wallName === 'G_F_L_R_S_W') {
            leftLineLengthOffset = 0.15;
            rightLineLengthOffset = 0.2;
            if (params.frontLeanStoragePosition === 0) {
                leftLineLengthOffset = 0.8;
                rightLineLengthOffset = -0.3;
            }
        } else if (wallName === 'G_B_L_L_S_W') {
            leftLineLengthOffset = 0.2;
            rightLineLengthOffset = 0.15;
            if (params.backLeanStoragePosition === 0) {
                leftLineLengthOffset = -0.3;
                rightLineLengthOffset = 0.8;
            }
        } else if (wallName === 'G_B_L_R_S_W') {
            leftLineLengthOffset = 0.15;
            rightLineLengthOffset = 0.2;
            if (params.backLeanStoragePosition === 0) {
                leftLineLengthOffset = 0.8;
                rightLineLengthOffset = -0.3;
            }
        }
        
        setWidthLeft(Math.abs(positionX - width / 2 - valLeft));
        setWidthRight(Math.abs(valRight - positionX - width / 2));
        setTopHeight(valTop - positionY - height / 2);
        setBottomHeight(positionY - height / 2 - valBottom);
        setLeftHorizontalArrowLength(arrowLeftHorizontalLengthTemp + leftLineLengthOffset);
        setRightHorizontalArrowLength(arrowRightHorizontalLengthTemp + rightLineLengthOffset);
        setVerticalArrowLength(limitY - positionY - height / 2);
        setLeftHorizontalArrowPosition(-(positionX - (limitX.min + arrowLeftHorizontalLengthTemp / 2)));
        setRightHorizontalArrowPosition(arrowRightHorizontalLengthTemp / 2 + width / 2);
        setTargetDoorSize(`${width * 12}"x${height * 12}"`)
    }, [id, width, height, limitX, limitY, positionX, positionY, wallName, params.p_r_p, params.singleSlope, bindDelta, const_var.newDoorsArray])

    // useEffect(() => {
    //     if (const_var.callMesure && isDrag) {
    //         let sideArray = const_var.newDoorsArray.filter((item) => item.userData.wallName === wallName);
    //         let sortArray = sortDoorObject(sideArray);

    //         const targetDoorObject = sortArray.find(item => item.uniqueId === id);
    //         setTargetDoorSize(convertSizeFormat(targetDoorObject.size, 'window'))
    //     }
    // }, [positionX, width, const_var.callMesure, const_var.newDoorsArray, isDrag, wallName, id]);

    useMemo(() => {
        if(limitX.min - (positionX - width / 2) > -3.3){
            if((params.p_l_w !== 'Open' && wallName === 'c_b_f_s_w') || 
                (params.p_f_w !== 'Open' && wallName === 'c_b_l_s_r_w') || 
                (params.p_b_w !== 'Open' && wallName === 'c_b_r_s_l_w') ||
                (params.p_b_c_b_l !== 'Open' && wallName === 'L_L_F_S_W') ||
                (params.p_r_w !== 'Open' && wallName === 'R_L_F_S_W') ||
                (params.p_b_w !== 'Open' && wallName === 'R_L_L_S_W') ||
                (params.p_b_c_b_f_l !== 'Open' && wallName === 'F_L_R_S_W') ||
                (params.p_b_w !== 'Open' && wallName === 'B_L_L_S_W')){
                    // setLeftPositionX(-width / 2)
                    setLeftAngle(Math.PI / 2)
                } else {
                // setLeftPositionX(-width / 2 - 2)
                setLeftAngle(0)
            }
        } else {
            // setLeftPositionX(-width / 2 - 2)
            setLeftAngle(0)
        }
        if(limitX.max - (positionX + width / 2) < 3.3){
            if((params.p_r_w !== 'Open' && wallName === 'c_b_f_s_w') || 
            (params.p_b_w !== 'Open' && wallName === 'c_b_l_s_r_w') || 
            (params.p_f_w !== 'Open' && wallName === 'c_b_r_s_l_w') ||
            (params.p_l_w !== 'Open' && wallName === 'L_L_F_S_W') ||
            (params.p_b_w !== 'Open' && wallName === 'L_L_R_S_W') ||
            (params.p_b_c_b_r !== 'Open' && wallName === 'R_L_F_S_W') ||
            (params.p_f_w !== 'Open' && wallName === 'F_L_R_S_W') || 
            (params.p_b_c_b_b_l !== 'Open' && wallName === 'B_L_L_S_W')) {
                // setRightPositionX(width / 2)
                setRightAngle(-Math.PI / 2)
            } else {
                // setRightPositionX(width / 2 + 2)
                setRightAngle(0)
            }
        } else {
            // setRightPositionX(width / 2 + 2)
            setRightAngle(0)
        }
    }, [limitX.min, limitX.max, params.p_l_w, wallName, params.p_f_w, params.p_b_w, params.p_r_w, params.p_l_w, params.p_b_c_b_r, params.p_b_c_b_b_l, params.p_b_c_b_f_l, params.p_b_c_b_l, width, positionX]);

    return const_var.callMesure && isDrag && (
        <group>
            <DimensionValue type={'window'} dir={'left'} position={[-width / 2, height / 2, 0.5]} rotation={[0, 0, leftAngle]} value={convertFeet(widthLeft) + ' W'} slopeAngle={0} cmpPosZ={positionZ} />
            <DimensionValue type={'window'} dir={'right'} position={[width / 2, height / 2, 0.5]} rotation={[0, 0, rightAngle]} value={convertFeet(widthRight) + ' W'} slopeAngle={0} cmpPosZ={positionZ} />
            <DimensionValue type={'window'} dir={'top'} position={[0, height / 2, 0.5]} value={convertFeet(topHeight) + ' H'} slopeAngle={0} cmpPosZ={positionZ} />
            <DimensionValue type={'window'} dir={'bottom'} position={[0, -height / 2, 0.5]} value={convertFeet(bottomHeight) + ' H'} slopeAngle={0} cmpPosZ={positionZ} />
            <DimensionValue type={'window'} dir={'center'} position={[0, height / 2 , 0.5]} value={targetDoorSize} slopeAngle={0} cmpPosZ={positionZ} />

            <group position={[leftHorizontalArrowPosition, 0, 0.3]}>
                <LineModel name="left-horizontal" length={lefthHorizontalArrowLength} position={[0, height / 2 - 0.1, 0]} rotation={[0, 0, Math.PI / 2]} color={color} />
            </group>
            <group position={[rightHorizontalArrowPosition, 0, 0.3]}>
                <LineModel name="horizontal" length={rightHorizontalArrowLength} position={[0, height / 2 - 0.1, 0]} rotation={[0, 0, Math.PI / 2]} color={color} />
            </group>
            <group position={[0, 0, 0.3]}>
                <LineModel name="top-vertical" length={verticalArrowLength} position={[0, verticalArrowLength / 2 + height / 2, 0]} color={color} />
            </group>
            <group position={[0, -positionY, 0.3]}>
                <LineModel name="bottom-vertical" length={positionY - height / 2} position={[0, (positionY - height / 2) / 2, 0]} color={color} />
            </group>
            <group>
            {sideDoorArray.map((item) => (
                <group key={item.uniqueId} position={[0, 0, 0]}>
                    <DoorSideLine length={height + 0.2} position={[-width / 2, -0.05, 0.5]} />
                    <DoorSideLine length={height + 0.2} position={[width / 2, -0.05, 0.5]} />
                </group>
            ))}
            </group>
        </group>
    )
}

export default Window_Measurements;